export default "__VITE_ASSET__a6ddc24a__"